import { buildElement, buildStyle } from '../../../utils/element'
import * as Mustache from 'mustache'
import { widgetState } from '../../../store/customizations/index'
import { SelectionOptions } from '../../../models/render-options'

export const buildSelection = (options: SelectionOptions, template: string) => {
  const element = buildElement('div', 'yotpo-selling-plan-select-container', {
    style: buildStyle({ display: shouldOpenByDefault() ? 'block' : 'none' }),
    'data-selling-plan-group-frequency-id': options.id
  })

  const html = Mustache.render(template, options)

  const innerElement = buildElement('div', options.classString, options.attributes || {})
  innerElement.innerHTML = html

  const selectEl = innerElement.querySelector('.yotpo-frequency-options')
  selectEl.addEventListener('change', (event) => {
    bindSelectionToInput(options.id)(event)
    markSelectedFrequencyLabel(event)
  })
  if (widgetState.customizations.showGetItText) {
    const labelForSelection = buildElement('label', 'yotpo-label-for-select-type', {})
    labelForSelection.innerText = widgetState.customizations.getItText
    element.appendChild(labelForSelection)
  }

  element.appendChild(innerElement)

  return element
}
const shouldOpenByDefault = (): boolean => {
  if (widgetState.customizations.selectionType === 'radio-and-dropdown') {
    return widgetState.customizations.styles.selectedRadio.openByDefault
  }
  return false
}
const bindSelectionToInput = (groupId: string) => (event: Event) => {
  const targetElement = <HTMLInputElement>event.target
  const sellingPlanId = targetElement.value
  const sellingPlanName = targetElement.getAttribute('data-label')
  const inputEl = document.querySelector(`.yotpo-radio-container[data-seling-plan-group-id="${groupId}"] .yotpo-radio-label-input`)
  inputEl.setAttribute('value', sellingPlanId)
  inputEl.setAttribute('data-selling-plan-name', sellingPlanName)
}

const markSelectedFrequencyLabel = (event: Event) => {
  const targetElement = <HTMLInputElement>event.target
  const sellingPlanId = targetElement.value
  document.querySelectorAll('.yotpo-frequency-label')
    .forEach(element => {
      const id = element.getAttribute('value')
      if (sellingPlanId === id) {
        element.classList.add('yotpo-frequency-selected')
      } else {
        element.classList.remove('yotpo-frequency-selected')
      }
    })
}
